/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDepartmentCommand,
  CreateDepartmentCommandResponse,
  DepartmentDetailQueryResponse,
  DepartmentQueryResponse,
  GetCompanyDepartmentsParams,
  UpdateDepartmentDto
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCompanyDepartments = (
    params: GetCompanyDepartmentsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DepartmentQueryResponse>(
      {url: `/api/v1/departments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompanyDepartmentsQueryKey = (params: GetCompanyDepartmentsParams,) => {
    return [`/api/v1/departments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyDepartmentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartments>>, GetCompanyDepartmentsParams['page']>, TError = ErrorType<unknown>>(params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']> = ({ signal, pageParam }) => getCompanyDepartments({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartments>>>
export type GetCompanyDepartmentsInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartments>>, GetCompanyDepartmentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartments>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartments>>, GetCompanyDepartmentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartments>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartments>>, GetCompanyDepartmentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartments>>, GetCompanyDepartmentsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData, Awaited<ReturnType<typeof getCompanyDepartments>>, QueryKey, GetCompanyDepartmentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartments>>> = ({ signal }) => getCompanyDepartments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartments>>>
export type GetCompanyDepartmentsQueryError = ErrorType<unknown>


export function useGetCompanyDepartments<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartments>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartments<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartments>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartments<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartments<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDepartmentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartments>>> = ({ signal }) => getCompanyDepartments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartments>>>
export type GetCompanyDepartmentsSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyDepartmentsSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentsSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentsSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartmentsSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartments>>, TError = ErrorType<unknown>>(
 params: GetCompanyDepartmentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createCompanyDepartment = (
    createDepartmentCommand: BodyType<CreateDepartmentCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateDepartmentCommandResponse>(
      {url: `/api/v1/departments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDepartmentCommand, signal
    },
      options);
    }
  


export const getCreateCompanyDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyDepartment>>, TError,{data: BodyType<CreateDepartmentCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyDepartment>>, TError,{data: BodyType<CreateDepartmentCommand>}, TContext> => {
    
const mutationKey = ['createCompanyDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyDepartment>>, {data: BodyType<CreateDepartmentCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyDepartment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyDepartment>>>
    export type CreateCompanyDepartmentMutationBody = BodyType<CreateDepartmentCommand>
    export type CreateCompanyDepartmentMutationError = ErrorType<unknown>

    export const useCreateCompanyDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyDepartment>>, TError,{data: BodyType<CreateDepartmentCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyDepartment>>,
        TError,
        {data: BodyType<CreateDepartmentCommand>},
        TContext
      > => {

      const mutationOptions = getCreateCompanyDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getCompanyDepartmentDetail = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DepartmentDetailQueryResponse>(
      {url: `/api/v1/departments/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyDepartmentDetailQueryKey = (id: number,) => {
    return [`/api/v1/departments/${id}`] as const;
    }

    
export const getGetCompanyDepartmentDetailInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>> = ({ signal }) => getCompanyDepartmentDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>
export type GetCompanyDepartmentDetailInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyDepartmentDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartmentDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentDetailInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDepartmentDetailQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>> = ({ signal }) => getCompanyDepartmentDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>
export type GetCompanyDepartmentDetailQueryError = ErrorType<unknown>


export function useGetCompanyDepartmentDetail<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetail<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyDepartmentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetail<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartmentDetail<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentDetailQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyDepartmentDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDepartmentDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>> = ({ signal }) => getCompanyDepartmentDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyDepartmentDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>>
export type GetCompanyDepartmentDetailSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyDepartmentDetailSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetailSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyDepartmentDetailSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyDepartmentDetailSuspense<TData = Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyDepartmentDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyDepartmentDetailSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateCompanyDepartment = (
    id: number,
    updateDepartmentDto: BodyType<UpdateDepartmentDto>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/departments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDepartmentDto
    },
      options);
    }
  


export const getUpdateCompanyDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDepartment>>, TError,{id: number;data: BodyType<UpdateDepartmentDto>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDepartment>>, TError,{id: number;data: BodyType<UpdateDepartmentDto>}, TContext> => {
    
const mutationKey = ['updateCompanyDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyDepartment>>, {id: number;data: BodyType<UpdateDepartmentDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompanyDepartment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDepartment>>>
    export type UpdateCompanyDepartmentMutationBody = BodyType<UpdateDepartmentDto>
    export type UpdateCompanyDepartmentMutationError = ErrorType<unknown>

    export const useUpdateCompanyDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDepartment>>, TError,{id: number;data: BodyType<UpdateDepartmentDto>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyDepartment>>,
        TError,
        {id: number;data: BodyType<UpdateDepartmentDto>},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteCompanyDepartment = (
    id: number,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/departments/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCompanyDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDepartment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDepartment>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteCompanyDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyDepartment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanyDepartment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyDepartment>>>
    
    export type DeleteCompanyDepartmentMutationError = ErrorType<unknown>

    export const useDeleteCompanyDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDepartment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyDepartment>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteCompanyDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    